export default __webpack_public_path__ + "static/media/DaimlerCAC-Regular.876bd8d4.ttf";